import { Tabs as a } from "./tabs.js";
export {
  a as Tabs
};
